<template>
  <button class="frisbuy-simple-button" @click="$emit('click')">
    <slot></slot>
  </button>
</template>

<style scoped lang="scss">
$primaryColor: #002354;

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

.frisbuy-simple-button {
  background-color: $primaryColor;
  color: #ffffff;
  border: 1px solid $primaryColor;

  width: 100%;
  max-width: 420px;

  font-family: sans-serif;
  font-size: 16px;
  font-weight: normal;
  text-align: center;

  transition: color 0.2s, background-color 0.2s;

  padding: 10px 40px;

  &:hover {
    background-color: #ffffff;
    color: $primaryColor;
  }
}
</style>

<script>
export default {
  emits: {
    click: null,
  },

  data() {
    return {};
  },
};
</script>
